import { frontendURL } from '../../../../helper/URLHelper';
import AiReplySettings from 'dashboard/routes/settings/aiReply/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-reply'),
      name: 'settings_ai_reply',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: AiReplySettings,
    },
  ],
};
